/**
 * Formats arrow CTA label with an arrow character.
 * @param {string} label
 * @param {string} arrow
 * @returns {string}
 */
export const formatCtaWithArrow = (label, arrow = " →") => {
  if (!label) return "";
  return `${label}${arrow}`;
};

/**
 * Returns card border class names based on featured state.
 * @param {boolean} isFeatured
 * @returns {string}
 */
export const getCardBorderClass = (isFeatured) => {
  if (isFeatured) {
    return "tw-border-[#4E39DF] hover:tw-border-[#3724B8]";
  }
  return "tw-border-slate-200 hover:tw-border-slate-300";
};
